import { sortOptions } from 'components/UnitsFilters/constants';
import { sortOptionsV2 } from './constantsV2';
import { AnyObject } from 'chart.js/types/basic';

export const actualizeSortOptions = (sortOption: string | undefined) => {
  const key = getKeyOfSortsOptions(sortOptionsV2, sortOptions, sortOption);
  if (!key) {
    return '';
  }

  return sortOptions[key as keyof typeof sortOptions];
};

function getKeyOfSortsOptions(
  options: AnyObject,
  fallbackOptions: AnyObject = {},
  value: string | undefined
): string | undefined {
  const keyFromV2Options = keyFromValue(options, value);
  if (!keyFromV2Options) {
    const keyFromOptions = keyFromValue(fallbackOptions, value);
    return keyFromOptions;
  }
  return keyFromV2Options;
}

const keyFromValue = (options: AnyObject, value: string | undefined) => {
  return Object.keys(options).find((key) => options[key] === value);
};
